import { Box } from "@mui/material";

type TabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
  expandedHeight?: number;
  barHeight?: number;
  withBox?: boolean;
  boxStyle?: any;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, barHeight, expandedHeight, withBox, boxStyle, ...other } = props;
  let content = props.children;
  
  let style = { p: 0, overflow: "auto" };
  if (withBox) {
    if (boxStyle) {
        style = boxStyle;
    }
  }
  content = <Box sx={style}>{children}</Box>;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && content}
    </div>
  );
}

export default TabPanel;